<template lang="pug">
ValidationObserver(ref='form' v-slot='{ handleSubmit, invalid }')
  envelope-step-bar(:step='4')
  form(@submit.prevent='handleSubmit(submit)')
    .col-12.mt-4
      .card.card--rounded
        .card-body.p-4
          form.form
            .row
              .col-12.col-sm-6
                ValidationProvider(
                  name='nome do envelope'
                  rules='required'
                  v-slot='{ errors }'
                )
                  .form-group
                    label.review-label(for='subject') {{ $t('modal.envelope.review.title') }}
                    .form-control-icon
                      icon(name='file')
                      input#subject.form-control(
                        :class='{ "border-danger": remainingCaracters.title === 0 }'
                        :placeholder='$t("modal.envelope.review.titlePlaceholder")'
                        autocomplete='off'
                        maxlength='60'
                        type='text'
                        v-model='title'
                      )
                      max-text-counter(
                        :limit='60'
                        :value='title'
                        @remaining='remainingCaracters.title = $event'
                      )
                    small.text.text-danger {{ errors[0] }}
              .col-12.col-sm-6
                .form-group
                  .form-check
                    input#saveToFolderCheckbox.form-check-input(
                      type='checkbox'
                      v-model='saveToFolderEnabled'
                    )
                    label.form-check-label.review-label(
                      for='saveToFolderCheckbox'
                    )
                      | {{ $t('modal.envelope.review.saveToFolder') }}
                      icon.fs-6.ms-1(
                        name='circle-question'
                        v-tooltip:top='$t("modal.envelope.review.saveToFolderHint")'
                      )
                  .form-control-icon.form-control-icon-select-folder(
                    :class='{ disabled: !saveToFolderEnabled }'
                    @click='saveToFolderEnabled && openModalSelectFolder()'
                  )
                    icon(name='folder')
                    .text.form-control(
                      :class='{ "text-muted": !saveToFolderEnabled }'
                    ) {{ textSelectedFolder }}
                      icon.text-end(name='chevron-right')
              .col-12.col-sm-6
                ValidationProvider(
                  name='envelope-limit-date'
                  rules='invalidDate'
                  v-slot='{ errors }'
                )
                  .form-group
                    label.review-label(for='signature-date-limit') {{ $t('modal.envelope.review.signatureDeadline') }}
                    .form-control-icon
                      icon(name='calendar')
                      date-picker-input#signature-date-limit.form-control(
                        :dateValue='expire_at'
                        :min-date='datePickMinDate'
                        :placeholder='$t("modal.envelope.review.signatureDeadlinePlaceholder")'
                        @change='validateDate($event, "signature-date-limit")'
                        type='text'
                        v-model='expire_at'
                      )
                    small.text.text-danger {{ errors[0] }}
              .col-12.col-sm-6(v-if='availableVisibilities.length')
                .form-group
                  label.review-label(for='visibility') {{ $t('modal.envelope.review.visibility') }}
                  select#visibility.form-control(v-model='visibilitySelected')
                    option(
                      :key='opt.value'
                      :value='opt.value'
                      v-for='opt in visibilityOptions'
                    ) {{ opt.label }}
              .col-12.col-sm-6(v-if='enableSignatureReminder')
                .form-group
                  label.review-label(for='signature-reminder')
                    | {{ $t('modal.envelope.review.signatureReminder') }}
                  select#signature-reminder.form-control(
                    v-model='action_reminder_frequency'
                  )
                    option(:value='null') {{ $t('modal.envelope.review.signatureReminderOptions.select') }}
                    option(value='24') {{ $t('modal.envelope.review.signatureReminderOptions.daily') }}
                    option(value='72') {{ $t('modal.envelope.review.signatureReminderOptions.every3Days') }}
                    option(value='120') {{ $t('modal.envelope.review.signatureReminderOptions.every5Days') }}
    .col-12.mt-4
      .card.card--rounded
        .card-body.p-4
          .row
            .col-12.col-sm-6
              ValidationProvider(
                name='signature-date-limit'
                rules='invalidDate'
                v-slot='{ errors }'
              )
                .form-group
                  label.review-label(for='subject') {{ $t('modal.envelope.review.subject') }}
                  .form-control-icon
                    icon(name='paper-plane')
                    input#subject.form-control(
                      :class='{ "border-danger": remainingCaracters.subject === 0 }'
                      :placeholder='$t("modal.envelope.review.subjectPlaceholder")'
                      autocomplete='off'
                      maxlength='60'
                      type='text'
                      v-model='subject'
                    )
                    max-text-counter(
                      :limit='60'
                      :value='subject'
                      @remaining='remainingCaracters.subject = $event'
                    )
            .col-12.mt-1
              .form-group
                label.review-label(for='message') {{ $t('modal.envelope.review.message') }}
                textarea#message.form-control(
                  :class='{ "border-danger": remainingCaracters.message === 0 }'
                  :placeholder='$t("modal.envelope.review.messagePlaceholder")'
                  maxlength='500'
                  style='min-height: 120px'
                  v-model='message'
                )
                max-text-counter(
                  :limit='500'
                  :value='message'
                  @remaining='remainingCaracters.message = $event'
                )
  envelope-bottom-bar(
    :disableButtonNextStep='invalid'
    :enableSaveTemplate='$route.name === "business.envelope.review"'
    :textButtonNextStep='$t("button.send")'
    @nextStep='nextStep'
    @save-template='saveAsTemplate = $event'
    @saveAndClose='saveAndClose'
  )
  envelope-sent-modal(ref='envelopeSentModal')
  select-folder-modal(
    :enableRootDirectory='true'
    @selected-folder='selectedFolder'
    ref='selectFolderModal'
  )
  warning-save-and-close-envelope-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='warningSaveAndCloseEnvelopeModal'
  )
    p.mb-0 {{ $t('modal.envelope.review.warningSaveAndClose') }}
  no-credit-modal(@saveAndClose='saveAndClose' ref='noCreditModal')
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import DatePickerInput from '@/ui/molecules/DatePickerInput.vue';
import EnvelopeState from '@/enums/EnvelopeState';
import EnvelopeSentModal from '@/modules/business/components/organisms/modals/EnvelopeSentModal.vue';
import NoCreditModal from '@/modules/business/components/organisms/modals/NoCreditModal.vue';
import EnvelopeStepBar from '@/ui/organisms/EnvelopeStepBar.vue';
import SelectFolderModal from '@/ui/organisms/modals/SelectFolderModal.vue';
import EnvelopeTriggerEvent from '@/enums/EnvelopeTriggerEvent';
import EnvelopeTrigger from '@/enums/EnvelopeTrigger';
// eslint-disable-next-line max-len
import WarningSaveAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseEnvelope.vue';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import StorageHttp from '@/services/StorageHttp';
import MaxTextCounter from '@/ui/atoms/MaxTextCounter.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';

export default {
  name: 'ReviewEnvelopePage',
  components: {
    Icon,
    DatePickerInput,
    EnvelopeSentModal,
    EnvelopeStepBar,
    SelectFolderModal,
    WarningSaveAndCloseEnvelopeModal,
    EnvelopeBottomBar,
    NoCreditModal,
    MaxTextCounter,
  },
  data() {
    return {
      envelope: '',
      loading: false,
      subject: '',
      title: '',
      expire_at: '',
      action_reminder_frequency: '',
      message: '',
      selectFolder: null,
      saveToFolderEnabled: false,
      nextRoute: null,
      saveAsTemplate: false,
      remainingCaracters: {
        subject: 60,
        message: 60,
        title: 500,
      },
      visibilitySelected: null,
      teams: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.envelope.fields' ||
      to.name === 'business.documents.sent' ||
      to.name === 'business.documents.draft'
    ) {
      next();
      return;
    }
    this.$refs.warningSaveAndCloseEnvelopeModal.$refs.modal.open();
    this.nextRoute = next;
  },
  computed: {
    selectWhetherToSaveOrSend() {
      return (
        this.envelope.state !== EnvelopeState.IN_TRANSIT &&
        this.envelope.state !== EnvelopeState.EXPIRED
      );
    },
    enableSignatureReminder() {
      return this.expire_at && this.expire_at !== 'invalidDate';
    },
    textSelectedFolder() {
      return this.selectFolder
        ? this.selectFolder.name
        : this.$t('modal.envelope.review.storage');
    },
    datePickMinDate() {
      return new Date().fp_incr(1);
    },
    availableVisibilities() {
      const organizationSelected = this.$store.state.organizations.selected;
      return (
        organizationSelected?.metadata['envelope.allowed_visibilities'] ?? []
      );
    },
    defaultVisibility() {
      const organizationSelected = this.$store.state.organizations.selected;
      return (
        organizationSelected?.metadata['envelope.default_visibility'] ?? null
      );
    },
    visibilityOptions() {
      const opts = [];
      const v = this.availableVisibilities;
      if (v.includes('private')) {
        opts.push({
          value: 'private',
          label: this.$t('modal.envelope.review.visibilityOptions.private'),
        });
      }
      if (v.includes('organization')) {
        opts.push({
          value: 'organization',
          label: this.$t(
            'modal.envelope.review.visibilityOptions.organization'
          ),
        });
      }
      if (v.includes('team')) {
        const prefix = this.$t(
          'modal.envelope.review.visibilityOptions.teamLabel'
        );
        this.teams.forEach((t) => {
          opts.push({ value: `team:${t.id}`, label: `${prefix} | ${t.name}` });
        });
      }
      return opts;
    },
  },
  watch: {
    visibilityOptions(opts) {
      if (this.visibilitySelected || !opts.length || !this.defaultVisibility) {
        return;
      }
      if (this.defaultVisibility === 'team') {
        const teamOption = opts.find((o) => o.value.startsWith('team:'));
        if (teamOption) {
          this.visibilitySelected = teamOption.value;
        }
      } else if (opts.some((o) => o.value === this.defaultVisibility)) {
        this.visibilitySelected = this.defaultVisibility;
      }
    },
  },
  created() {
    let pageTitle = this.$route.params.isNew
      ? this.$t('newEnvelope')
      : this.$t('editEnvelope');
    this.$store.dispatch('page/setTitle', pageTitle);
    this.$store.dispatch('page/setHead', {
      title: pageTitle,
      action: () => {
        this.$router.replace({
          name: 'business.envelope.fields',
          params: {
            id: this.$route.params.id,
            isNew: this.$route.params.isNew,
          },
        });
      },
    });
  },
  async beforeMount() {
    const res = await EnvelopesService.getExtendedEnvelope(
      this.$route.params.id
    );
    const fileDirectory = res.data.triggers.find(
      (x) => x.trigger === EnvelopeTrigger.SAVE_FILES_ON_DIRECTORY
    );
    if (fileDirectory) {
      this.saveToFolderEnabled = true;
      StorageHttp.getItem(fileDirectory.value).then((result) => {
        this.selectedFolder(result.data);
      });
    }
    this.envelope = res.data;
    this.title = String(this.envelope.title.split('.', 1));
    this.subject = this.envelope.subject;
    this.expire_at = this.envelope.expire_at
      ? new Date(this.envelope.expire_at).fp_incr(1)
      : '';
    this.action_reminder_frequency = this.envelope.action_reminder_frequency;
    this.message = this.envelope.message;

    if (this.availableVisibilities.includes('team')) {
      try {
        const res = await TeamsService.list();
        this.teams = res.data.data;
      } catch (e) {
        this.teams = [];
      }
    }

    const visibilityOpts = this.visibilityOptions;
    if (this.envelope.visibility) {
      let candidate;
      if (this.envelope.visibility === 'team') {
        const teamId = this.envelope.team;
        if (teamId) {
          candidate = `team:${teamId}`;
        }
      } else {
        candidate = this.envelope.visibility;
      }
      if (candidate && visibilityOpts.some((o) => o.value === candidate)) {
        this.visibilitySelected = candidate;
      } else if (this.defaultVisibility) {
        this.visibilitySelected = this.defaultVisibility;
      }
    } else if (this.defaultVisibility) {
      this.visibilitySelected = this.defaultVisibility;
    }

    if (this.visibilitySelected === 'team') {
      const teamOption = visibilityOpts.find((o) =>
        o.value.startsWith('team:')
      );
      this.visibilitySelected = teamOption ? teamOption.value : null;
    }

    if (this.defaultVisibility === 'team') {
      const lastVisibility = await this.$store.dispatch(
        'envelopeSettings/getLastVisibility'
      );
      if (lastVisibility) {
        const teamVisibility = `team:${lastVisibility}`;
        if (visibilityOpts.some((o) => o.value === teamVisibility)) {
          this.visibilitySelected = teamVisibility;
        }
      }
    }
  },
  methods: {
    async saveDetails() {
      this.$loading(true);
      const data = {};
      data.title = this.title;
      data.subject = this.subject;
      data.triggers = [];
      if (this.saveToFolderEnabled) {
        data.triggers.push({
          event: EnvelopeTriggerEvent.ENVELOPE_COMPLETED,
          trigger: EnvelopeTrigger.SAVE_FILES_ON_DIRECTORY,
          value: this.selectFolder ? this.selectFolder.id : null,
        });
      }
      data.action_reminder_frequency = this.action_reminder_frequency;
      if (this.expire_at) {
        data.expire_at = this.expire_at;
      }
      if (this.message) {
        data.message = this.message;
      }
      await EnvelopesService.update(this.$route.params.id, data);

      if (this.availableVisibilities.length && this.visibilitySelected) {
        let visibility = this.visibilitySelected;
        let team = null;
        if (visibility.startsWith('team:')) {
          team = visibility.replace('team:', '');
          visibility = 'team';
        }
        const payload = { visibility };
        if (team) {
          payload.team = team;
        }
        await EnvelopesService.changeVisibility(this.$route.params.id, payload);
      }

      if (this.visibilitySelected?.startsWith('team:')) {
        await this.$store.dispatch(
          'envelopeSettings/saveLastVisibility',
          this.visibilitySelected.replace('team:', '')
        );
      }

      if (this.saveAsTemplate) {
        await EnvelopesService.copyTo('template', this.$route.params.id);
      }
      this.$loading(false);
    },
    validateDate(event, inputId) {
      if (event === 'invalidDate') {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.add('border-danger');
      } else {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.remove('border-danger');
      }
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.saveDetails();
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.draft' });
    },
    async nextStep() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }
        if (!this.$store.getters['subscription/hasCredits']) {
          this.$refs.noCreditModal.$refs.modal.open();
          return;
        }

        await this.saveDetails();
        this.$loading(true);
        try {
          if (this.selectWhetherToSaveOrSend) {
            await EnvelopesService.sendEnvelope(this.$route.params.id);
            this.$store.dispatch('subscription/getSubscription');
          }
          this.$refs.envelopeSentModal.$refs.modal.open();
        } catch (error) {
          if (error.response.status === 402) {
            this.$refs.noCreditModal.$refs.modal.open();
          }
        } finally {
          this.$loading(false);
        }
      });
    },
    openModalSelectFolder() {
      this.$refs.selectFolderModal.$refs.modal.open();
    },
    selectedFolder(folder) {
      if (!folder) {
        this.selectFolder = null;
        return;
      }

      this.selectFolder = {
        name: folder.name,
        id: folder.id,
      };
    },
  },
};
</script>
<style lang="stylus">
.w-center
  margin: auto
  max-width: 960px
.form-control-icon-select-folder
  cursor: pointer;
  .icon
    color: #013d52
  .form-control
    padding-top: 0.7rem
    display: flex;
    justify-content: space-between;
  &.disabled
    opacity: 0.5
    pointer-events: none
    cursor: not-allowed
.review-label
  font-size: 1rem
.review-radius
  border-radius: .125rem
</style>
